"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var style = {
  "bar": "au_progressbar-module__bar___wwpvQ",
  "no-background": "au_progressbar-module__no-background___gFxbj",
  "active": "au_progressbar-module__active___AyWfM",
  "move": "au_progressbar-module__move___fbDDv"
};
class AuProgressBar extends _react.default.PureComponent {
  render() {
    let {
      max,
      value,
      className,
      isAnimated
    } = this.props;
    const width = value >= max ? 100 : value / max * 100;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(className, style.bar, {
        [style.active]: isAnimated
      })
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        width: `${width}%`
      }
    }, /*#__PURE__*/_react.default.createElement("span", null)));
  }
  static propTypes = {
    max: T.number,
    value: T.number.isRequired,
    className: T.string,
    isAnimated: T.bool
  };
  static defaultProps = {
    max: 100,
    className: '',
    isAnimated: false
  };
}
exports.default = AuProgressBar;